import { createIcon } from '@chakra-ui/icons';

export const PointerFilled = createIcon({
  displayName: 'PointerFilled',
  viewBox: '0 0 24 24',
  d: 'M23.134 0.698906L0.0986585 10.3364L0.0986593 11.6047L8.84297 14.9899L12.2281 23.7342H13.4965L23.134 0.698906Z',
});
